export const isValidDragAndDrop = (result, provided) => {
  if (result && result.source && result.destination) {
    return true;
  }
  return false;
};
